import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { OVERLAY_DISPLAY_ATTR } from 'shared/constants/web';

import { BASE_COLOR } from 'shared/constants/colors';
import { overlayClose } from 'shared/actions/view/web';
import { compose } from 'shared/helpers';

import {
  SvgIcon,
  RotateButton,
  CircularSpinner,
} from 'components/elems';


const { SUSPEND_EXIT_WITH_SPINNER } = OVERLAY_DISPLAY_ATTR;

const Spinner = () => (
  <CircularSpinner
    size={44}
    strokeWidth={3}
  />
);


// Match size with other sibling buttons, e.g. Ready.
const CloseIcon = () => <SvgIcon.strl.Remove1F size={26} />;


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    overlayClose,
  }, dispatch);
}


const OverlayCloseControl = ({
  overlayDisplayAttrs,
  ...props
}) => {
  // TODO: Maybe make it configurable by 'type' prop?
  return (overlayDisplayAttrs.includes(SUSPEND_EXIT_WITH_SPINNER)
    ? <Spinner />
    : <RotateButton
        icon={<CloseIcon />}
        style={{ color: BASE_COLOR.darkGray }}
        onClick={props.overlayClose}
      />
  );
};


export default compose(
  connect(null, mapDispatchToProps),
)(OverlayCloseControl);



// WEBPACK FOOTER //
// ./src/components/navs/_navbar/OverlayCloseControl.js